export default {
  TOGGLE_LOADING(state) {
    state.callingAPI = !state.callingAPI
  },

  setUserID(state, id) {
    state.PsjID = id
  },

  setVisitorID(state, id) {
    state.PsnID = id
  },

  setPreviousUser(state) {
    state.isPreviousUser = true
  },

  setUserInfo(state, data) {
    state.userInfo = data
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js